import Vue from "vue";
import Router from "vue-router";
import Configuration from "./config/config";

Vue.use(Router);

const meta = {
    layout: Configuration.value("VUE_APP_COMPONENT_LAYOUT") || "default/Default",
    hasBackground: true
};

/**
 * @returns {VueRouter}s
 */
export function createRouter(): Router {
    return new Router({
        mode: "history", // get rid of hash based routes and switch to history mode
        routes: [
            {
                path: "/selbstauskunft/:digitalOrderingId",
                component: () => import("./views/SelfDisclosureWrapper.vue"),
                meta: {
                    ...meta
                },
                children: [
                    {
                        path: "",
                        name: "selfDisclosureLogin",
                        component: () => import("./views/SelfDisclosureLogin.vue"),
                        meta: {
                            ...meta
                        },
                    },
                    {
                        path: "pruefen",
                        name: "selfDisclosureOverview",
                        component: () => import("./views/SelfDisclosureOverview.vue"),
                        meta: {
                            ...meta
                        }
                    },
                    {
                        path: "ausfuellen",
                        name: "selfDisclosure",
                        component: () => import("./views/SelfDisclosure.vue"),
                        meta: {
                            ...meta
                        }
                    },
                    {
                        path: "zustimmen",
                        name: "selfDisclosureTerms",
                        component: () => import("./views/SelfDisclosureTerms.vue"),
                        meta: {
                            ...meta
                        }
                    },
                    {
                        path: "erledigt",
                        name: "selfDisclosureDone",
                        component: () => import("./views/SelfDisclosureDone.vue"),
                        meta: {
                            ...meta
                        }
                    },
                ]
            },
            {
                path: "/nachweise/erfolg",
                name: "paySlipSuccess",
                component: () => import("./views/PaySlipSuccess.vue"),
                meta: {
                    ...meta
                }
            },
            {
                path: "/nachweise/fehler",
                name: "paySlipError",
                component: () => import("./views/PaySlipError.vue"),
                meta: {
                    ...meta
                }
            },
            {
                path: "/nachweise/:digitalOrderingId",
                component: () => import("./views/PaySlipWrapper.vue"),
                meta: {
                    ...meta
                },
                children: [
                    {
                        path: "",
                        name: "paySlipLogin",
                        component: () => import("./views/PaySlipLogin.vue"),
                        meta: {
                            ...meta
                        }
                    },
                    {
                        path: "hochladen",
                        name: "paySlip",
                        component: () => import("./views/PaySlip.vue"),
                        meta: {
                            ...meta
                        }
                    },
                    {
                        path: "erledigt",
                        name: "paySlipDone",
                        component: () => import("./views/PaySlipDone.vue"),
                        meta: {
                            ...meta
                        }
                    }
                ]
            },
            {
                path: "/identifizierung/erfolg",
                name: "identificationSuccess",
                component: () => import("./views/IdentificationSuccess.vue"),
                meta: {
                    ...meta
                }
            },
            {
                path: "/identifizierung/fehler",
                name: "identificationError",
                component: () => import("./views/IdentificationError.vue"),
                meta: {
                    ...meta
                }
            },
            {
                path: "/meinauto-abo/:digitalOrderingId",
                component: () => import("./views/SelfDisclosureWrapper.vue"),
                meta: {
                    ...meta
                },
                children: [
                    {
                        path: "",
                        name: "flatrateLogin",
                        component: () => import("./views/FlatrateLogin.vue"),
                        meta: {
                            ...meta
                        }
                    },
                    {
                        path: "nachweise",
                        name: "flatrateData",
                        component: () => import("./views/FlatrateDocuments.vue"),
                        meta: {
                            ...meta
                        }
                    }
                ]
            },
            {
                path: "*",
                name: "error",
                props: true,
                component: () => import(/* webpackChunkName: "error" */ "./views/Error.vue"),
                meta: {
                    layout: "default/Default",
                    title: "404"
                }
            }
        ]
    } as any); //@todo fix interface
}
